<template>
  <div>
    <el-tabs
      v-model="activeName"
      type="border-card"
      class="mt-2"
      style="box-shadow:none"
    >
      <el-tab-pane
        :label="$l('INDEX.form_label_base_info') || '基本信息'"
        name="base"
        lazy
      >
        <edit-form
          :disabled="isDisableEditForm"
          :sampleCode="sampleCode"
          :productLine.sync="productLine"
          :masterCategoryCode.sync="masterCategoryCode"
          :proofingCode="proofingCode"
          ref="editForm"
          @reload="(val) => $emit('reload', val)"
        />
        <div class="d-flex justify-content-end mt-2 mb-2">
          <el-button
            v-if="!isDisableEditForm"
            size="mini"
            type="primary"
            @click="() => $refs.editForm.save()"
          >
            {{ $l('INDEX.btn_save') || '保存' }}
          </el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane
        :label="$l('form_label_image') || '样品图片'"
        name="image-data"
        :disabled="isAddOperation"
        lazy
      >
        <image-data
          :sampleCode="sampleCode"
          :proofingCode="proofingCode"
          :disabled="isDisableEditForm"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('form_label_fabric_composition') || '面料构成'"
        :disabled="isAddOperation || !productLine"
        lazy
      >
        <sample-fabric-material
          :sampleCode="sampleCode"
          :disabled="isDisableEditForm"
          :productLine="productLine"
          :categoryCode="masterCategoryCode"
          :proofingCode="proofingCode"
          ref="contactTable"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('form_label_accessories_composition') || '辅料构成'"
        :disabled="isAddOperation || !productLine"
        lazy
      >
        <sample-accessory-material
          :sampleCode="sampleCode"
          :disabled="isDisableEditForm"
          :productLine="productLine"
          :categoryCode="masterCategoryCode"
          :proofingCode="proofingCode"
          ref="contactTable"
        />
      </el-tab-pane>
      <el-tab-pane
        v-if="!proofingCode"
        :label="$l('form_label_link_data') || '关联业务单'"
        name="data"
        :disabled="isAddOperation"
        lazy
      >
        <sample-link
          :sampleCode="sampleCode"
          :proofingCode="proofingCode"
          :disabled="isDisableEditForm"
      /></el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import ImageData from './components/image-data'
import SampleLink from './components/sample-link'
import SampleFabricMaterial from './components/sample-fabric-material'
import SampleAccessoryMaterial from './components/sample-accessory-material'
export default {
  name: 'sample-sampleInformation-detail',
  components: {
    EditForm,
    ImageData,
    SampleFabricMaterial,
    SampleAccessoryMaterial,
    SampleLink,
  },
  props: {
    openType: { type: String, default: '' },
    parmsData: { type: Object, default: () => {} },
  },
  data() {
    return {
      activeName: 'base',
      sampleCode: '',
      productLine: '',
      masterCategoryCode: '',
    }
  },
  watch: {
    parmsData: {
      handler(val) {
        const {
          sampleCode: sampleCode_r = '',
          productLine: productLine_r = '',
          masterCategoryCode: masterCategoryCode_r = '',
        } = this.params || {}
        if (sampleCode_r) this.sampleCode = sampleCode_r
        if (productLine_r) this.productLine = productLine_r
        if (masterCategoryCode_r) this.masterCategoryCode = masterCategoryCode_r

        const { sampleCode, productLine, masterCategoryCode } = val || {}
        if (sampleCode) this.sampleCode = sampleCode
        if (productLine) this.productLine = productLine
        if (masterCategoryCode) this.masterCategoryCode = masterCategoryCode
      },
      immediate: true,
    },
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    pageHeader() {
      const types = {
        edit: this.$l('form_label_sample_edit') || '编辑样品信息',
        add: this.$l('form_label_sample_add') || '添加样品信息',
        detail: this.$l('form_label_sample_detail') || '样品信息详情',
      }
      return types[this.pageType]
    },
    isDisableEditForm() {
      if (this.proofingCode) return this.openType === 'detail'
      return this.pageType === 'detail'
    },
    isAddOperation() {
      if (this.proofingCode) return this.openType === 'add'
      return this.pageType === 'add'
    },
    proofingCode() {
      if (!this.parmsData) return ''
      return this.parmsData.proofingCode || ''
    },
  },
  mounted() {},
}
</script>
